import React from 'react';
import Layout from '../components/Layout';

const PrivacyPolicy = () => {
  return (
    <Layout>
      <section id="greenorange-dest">
        <section className="banner">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <h1 className="mar0">Privacy Policy</h1>
                <p className="colorWht">Green Orange Privacy Policies</p>
              </div>
            </div>
          </div>
        </section>
        <div className="clearfix"></div>
        <section className="content-dest1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 privacy_policy">
                <h3>Key Details</h3>
                <p>This website privacy policy describes how [company name] protects and makes use of the information you give the company when you use this website.</p>
                <p>If you are asked to provide information when using this website, it will only be used in the ways described in this privacy policy.</p>
                <p>This policy is updated from time to time. The latest version is published on this page.</p>
                <p>This website privacy policy was updated on: 07/10/2015</p>
                <p>If you have any questions about this policy, please email us to sales@greenorange.in or write to:</p>
                <p>
                  Green Orange Information Technology<br />
                  G-36 & 37, Tidel Park, ELCOT SEZ<br />
                  Vilankurichi Road, Civil Aerodrome Post,<br />
                  Coimbatore-641014, Tamilnadu, India<br />
                  Telephone: +91 422 2412454
                </p>
                <h3>Introduction</h3>
                <p>We gather and use certain information about individuals in order to provide products and services and to enable certain functions on this website.</p>
                <p>We also collect information to better understand how visitors use this website and to present timely, relevant information to them.</p>
                <h3>What data we gather</h3>
                <p>We may collect the following information:</p>
                <ul>
                  <li>Name and job title</li>
                  <li>Contact information including email address</li>
                  <li>Demographic information, such as postcode, preferences and interests</li>
                  <li>Website usage data</li>
                  <li>Other information relevant to client enquiries</li>
                  <li>Other information pertaining to special offers and surveys</li>
                </ul>
                <h3>How we use this data</h3>
                <p>Collecting this data helps us understand what you are looking from the company, enabling us to deliver improved products and services.</p>
                <p>Specifically, we may use data:</p>
                <ul>
                  <li>For our own internal records</li>
                  <li>To improve the products and services we provide</li>
                  <li>To contact you in response to a specific enquiry</li>
                  <li>To customise the website for you</li>
                  <li>To send you promotional emails about products, services, offers and other things we think might be relevant to you.</li>
                  <li>To send you promotional mailings or to call you about products, services, offers and other things we think might be relevant to you.</li>
                  <li>To contact you via email, telephone or mail for market research reasons.</li>
                </ul>
                <h3>Cookies and how we use them</h3>
                <h4>What is a cookie?</h4>
                <p>A cookie is a small file placed on your computer's hard drive. It enables our website to identify your computer as you view different pages on our website.</p>
                <p>Cookies allow websites and applications to store your preferences in order to present content, options or functions that are specific to you. They also enable us to see information like how many people use the website and what pages they tend to visit.</p>
                <h4>How we use cookies</h4>
                <p>We may use cookies to:</p>
                <p>
                  <strong>Analyse our web traffic using an analytics package.</strong>
                  <br />
                  Aggregated usage data helps us improve the website structure, design, content and functions.
                </p>
                <p>
                  <strong>Identify whether you are signed in to our website.</strong>
                  <br /> A cookie allows us to check whether you are signed in to the site.
                </p>
                <p>
                  <strong>Test content on our website.</strong>
                  <br />
                  For example, 50% of our users might see one piece of content, the other 50% a different piece of content.
                </p>
                <p>
                  <strong>Store information about your preferences.</strong>
                  <br /> The website can then present you with information you will find more relevant and interesting.
                </p>
                <p>
                  <strong>To recognise when you return to our website.</strong>
                  <br /> We may show your relevant content, or provide functionality you used previously.
                </p>
                <p>Cookies do not provide us with access to your computer or any information about you, other than that which you choose to share with us.</p>
                <h4>Controlling cookies</h4>
                <p>You can use your web browser's cookie settings to determine how our website uses cookies. If you do not want our website to store cookies on your computer or device, you should set your web browser to refuse cookies.</p>
                <p>However, please note that doing this may affect how our website functions. Some pages and services may become unavailable to you.</p>
                <p>Unless you have changed your browser to refuse cookies, our website will issue cookies when you visit it.</p>
                <p>To learn more about cookies and how they are used, visit All About Cookies.</p>
                <h3>Controlling information about you</h3>
                <p>When you fill in a form or provide your details on our website, you will see one or more tick boxes allowing you to:</p>
                <ul>
                  <li>Opt-in to receive marketing communications from us by email, telephone, text message or post.</li>
                  <li>Opt-in to receive marketing communications from our third-party partners by email, telephone, text message or post.</li>
                </ul>
                <p>If you have agreed that we can use your information for marketing purposes, you can change your mind easily, via one of these methods:</p>
                <ul>
                  <li>Sign in to our website and change your opt-in settings.</li>
                  <li>Send an email to support@greenorange.in.</li>
                  <li>
                    Write to us at: GreenOrange Information Technology Private Limited, G36&37, TIDEL Park, ELCOT-SEZ, Vilankurichi road, Aerodrome post, Coimbatore, 641014, Tamil Nadu, India.
                  </li>
                </ul>
                <p>We will never lease, distribute or sell your personal information to third parties unless we have your permission or the law requires us to.</p>
                <p>Any personal information we hold about you is stored and processed under our data protection policy, in line with the Data Protection Act 1998.</p>
                <h3>Security</h3>
                <p>We will always hold your information securely.</p>
                <p>To prevent unauthorised disclosure or access to your information, we have implemented strong physical and electronic security safeguards.</p>
                <p>We also follow stringent procedures to ensure we work with all personal data in line with the Data Protection Act 1998.</p>
                <h3>Links from our site</h3>
                <p>Our website may contain links to other websites.</p>
                <p>Please note that we have no control of websites outside the Green Orange domain. If you provide information to a website to which we link, we are not responsible for its protection and privacy.</p>
                <p>Always be wary when submitting data to websites. Read the site's data protection and privacy policies fully.</p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default PrivacyPolicy;

